import React from "react";

const poshComplaintRows = [
  {
    label:
      "Total complaints reported under sexual harassment on woman at workplace (Prevention, Prohibition, Redressal) Act,2013 (POSH)",
    key: "totalComplaints",
    current: "",
    previous: "",
  },
  {
    label: "Complaints on POSH as a % of female employees/ workers",
    key: "percentComplaints",
    current: "",
    previous: "",
  },
  {
    label: "Complaints on POSH upheld",
    key: "complaintsUpheld",
    current: "",
    previous: "",
  },
];

const PoshComplaintsTable = ({ poshData, setPoshData }) => {
  const handleChange = (index, context, value) => {
    const updated = [...poshData];
    updated[index][context] = value;
    setPoshData(updated);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0,
          borderRadius: "12px",
        }}
      >
        <thead>
          <tr>
            <th style={{ ...headerStyle, borderTopLeftRadius: "10px" }}>
              Indicate product category
            </th>
            <th style={{ ...headerStyle }}>Current FY</th>
            <th style={{ ...headerStyle, borderTopRightRadius: "10px" }}>
              Previous FY
            </th>
          </tr>
        </thead>
        <tbody>
          {poshData.map((row, index) => (
            <tr key={index}>
              <td style={leftCellStyle}>{row.label}</td>
              <td style={rightCellStyle}>
                <input
                  type="text"
                  placeholder="Enter value"
                  value={row.current || ""}
                  onChange={(e) =>
                    handleChange(index, "current", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={rightCellStyle}>
                <input
                  type="text"
                  placeholder="Enter value"
                  value={row.previous || ""}
                  onChange={(e) =>
                    handleChange(index, "previous", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "14px",
  border: "1px solid #a99aa6",
  fontWeight: "bold",
  textAlign: "left",
  backgroundColor: "#D3C9CE",
};

const leftCellStyle = {
  padding: "14px",
  border: "1px solid #a99aa6",
  fontWeight: 500,
  backgroundColor: "#fff",
  verticalAlign: "top",
  textAlign: "left",
};

const rightCellStyle = {
  padding: "14px",
  border: "1px solid #a99aa6",
  backgroundColor: "#fff",
  textAlign: "center",
};

const inputStyle = {
  width: "80%",
  padding: "10px",
  fontSize: "14px",
  border: "1px solid grey",
  borderRadius: "6px",
  textAlign: "center",
  outline: "none",
};

export default PoshComplaintsTable;
